import Reflux from "reflux";
import UIActions from "../actions/UIActions";

const DEFAULT_DURATION = 2000;
const SHOW_NEXT_TOAST_DELAY = 100;

const ToastStore = Reflux.createStore({
  storeName: 'ToastStore',
  listenables: UIActions,

  init() {
    this.toast = { active: false };
    this.toastQueue = [];
    this.toastTimeout = null;
  },

  onShowToast(data) {
    if (this.toast.active) {
      this.toastQueue.push(data);
      return;
    }

    this._showToast(data);
  },

  _showToast(data) {
    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout);
      this.toastTimeout = null;
    }

    this.toast = { ...data, active: true };
    this.trigger(this.toast);

    const duration = data.dur ?? DEFAULT_DURATION;
    if (duration > 0) {
      this.toastTimeout = setTimeout(() => {
        this.toastTimeout = null;
        this._hideToast();
        this._showNextInQueue();
      }, duration);
    }
  },

  onHideToast() {
    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout);
      this.toastTimeout = null;
    }
    this._hideToast();
    this._showNextInQueue();
  },

  _hideToast() {
    this.toast.active = false; // need to retain toast to preserve styles on unmount
    this.trigger(this.toast);
  },

  _showNextInQueue() {
    if (this.toastQueue.length > 0) {
      setTimeout(() => {
        const nextToast = this.toastQueue.shift();
        this._showToast(nextToast);
      }, SHOW_NEXT_TOAST_DELAY);
    }
  },

  getInitialState() {
    return this.toast;
  },
});

export default ToastStore;
